import { cdnify } from "../core/cdn";
import { FeedBackFontFilesType, FeedBackFontType } from "../types/feedback.types";

const fontExtensions: Record<string, string> = {
  ".ttf": "truetype",
  ".otf": "opentype",
  ".woff": "woff",
  ".woff2": "woff2",
};

export function extension(filename: string) {
  const matches = filename.match(/\.[0-9a-z]+$/i);
  if (matches) return matches[0];
  return "";
}

function fontFormatFromName(filename: string) {
  const ext = extension(filename);
  if (fontExtensions[ext]) {
    return fontExtensions[ext];
  }
  return;
}

type FileType = {
  id: number;
  _id: string;
  mimeType: string;
  size: number;
  uri: string;
  originalFilename: string;
};

export function fontFace(name: string, type: string, file: FileType) {
  if (!name || !file || !file.uri) return "";
  const format = fontFormatFromName(file.uri);
  if (!format) return "";

  return `
    /* ${type} */
    @font-face {
        font-family: "${name}";
        src: url("${cdnify(file.uri)}") format("${format}");
    ${type === "italic" || type === "boldItalic" ? "    font-style: italic;" : ""}
    ${type === "bold" || type === "boldItalic" ? "    font-weight: bold;" : ""}
    }`;
}

export function fontFaces(name: string, files: FeedBackFontFilesType) {
  if (!files) return "";

  return Object.keys(files)
    .map((type) => fontFace(name, type, files[type]))
    .join("\n");
}

export function cssForFont(font: FeedBackFontType) {
  if (!font) return null;
  const { name, fallbacks, files } = font.body;

  return `
    ${fontFaces(name, files)}
    
    .wrapper {
        font-family: "${name}", ${fallbacks || "sans-serif"};
    }
    `;
}
